import axios from 'axios';

export const confirmOrder = (orderId: string) => {
    return axios.post('Orders/ConfirmOrderByEmail/' + orderId);
};
